var t={left:"rotate-180",right:"",down:"rotate-90",up:"-rotate-90"};export{t as D};
//# sourceMappingURL=directions.js.map
